import {
  REFERENCING_FIELD,
  OWNER_FIELD,
  EMPTY_CONDITION,
  getValueSourceRadioButtonsWithSlug,
  VALUE_SOURCE_RADIO_BUTTONS_WITHOUT_UOU_FILTERS,
  STATIC_WITHOUT_VALUE_SOURCE_SECTION,
} from './enums/dimensions'

import { isMultiReferenceField } from '@wix/wix-data-client-common/dist/esm/business-logic/fields/fieldQueries'

const getPanelDimensions = ({
  panelValue,
  field,
  isTPACollection,
  isCmsMultiRefFilterEnabled,
  isSlugFilterAllowedInPage,
  allowValueSourceSelection,
}) => {
  const { STATIC, DATASET, STATIC_MULTI_REFERENCE, SLUG } =
    isSlugFilterAllowedInPage
      ? getValueSourceRadioButtonsWithSlug()
      : VALUE_SOURCE_RADIO_BUTTONS_WITHOUT_UOU_FILTERS

  return panelValue.matchWith({
    Owner: () => OWNER_FIELD,
    Referencing: () =>
      isMultiReferenceField(field) &&
      (isTPACollection || isCmsMultiRefFilterEnabled)
        ? STATIC_MULTI_REFERENCE
        : REFERENCING_FIELD,
    Static: () =>
      allowValueSourceSelection ? STATIC : STATIC_WITHOUT_VALUE_SOURCE_SECTION,
    Dataset: () => DATASET,
    StaticMultiRef: () => STATIC_MULTI_REFERENCE,
    Slug: () => SLUG,
    Empty: () => EMPTY_CONDITION,
  })
}

export default getPanelDimensions
